import { IProfile, IProfileDomain } from '../types/users';

export function isMetricalUser(profile: IProfile): boolean {
  return profile.organizations.some((x) => x.master);
}

export function findProfileDomain(
  profile: IProfile,
  domainId: number | string | undefined,
  organizationId?: number | string,
): IProfileDomain | undefined {
  if (domainId == null) {
    return undefined;
  }
  const targetDomainId = Number(domainId);
  if (organizationId != null) {
    const org = profile.organizations.find((x) => Number(x.id) === Number(organizationId));
    const domain = org?.domains.find((d) => Number(d.id) === targetDomainId);
    if (domain) {
      return domain;
    }
  }
  return profile.organizations
    .flatMap((org) => org.domains)
    .find((d) => Number(d.id) === targetDomainId);
}

export function isDomainInMaintenanceMode(domain: IProfileDomain | undefined): boolean {
  return domain?.maintenanceMode === true;
}

export function shouldShowDashboardMaintenance(
  profile: IProfile,
  domainId: number | string | undefined,
  organizationId: number | string | undefined,
  isDashboard?: boolean,
): boolean {
  if (!isDashboard) {
    return false;
  }
  if (isMetricalUser(profile)) {
    return false;
  }
  const domain = findProfileDomain(profile, domainId, organizationId);
  return isDomainInMaintenanceMode(domain);
}
